<div class="elementsBar row">
  <div class="elementsBarBtns col-6">
    <button mat-button (click)="favouriteClick()" [style.color]="favColor">
      <svg class="pc-icon">
        <use xlink:href="assets/fonts/custom-icon.svg#star-colored"></use>
      </svg>
      {{ 'addtoFavorite' | translate }}
    </button>
  </div>

  <div class="searchExport col-6 p-t-20">

    @if (permissions?.print || permissions?.export) {
    <mat-form-field appearance="outline" class="Export">
      <mat-label>{{ 'more' | translate }}</mat-label>
      <mat-select [(ngModel)]="selectedOption" name="exOption">
        @for (exOption of exportOptions; track exOption) {
        <mat-option [value]="exOption.value" (click)="onOptionClicked(exOption.value)">{{ exOption.viewValue | translate
          }}</mat-option>
        }
        @for (item of extraDynamicMenu; track item) {
        <mat-option [value]="'Command_' + item.functionName"
          (click)="onOptionClicked('Command_' + item.functionName)">{{
          item.commandName | translate
          }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    }
  </div>
</div>
<app-base-criteria>
  <ng-content select="[criteria]"></ng-content>
</app-base-criteria>